import { render, staticRenderFns } from "./GsaApprove.vue?vue&type=template&id=7f1bc2f4&"
import script from "./GsaApprove.vue?vue&type=script&lang=js&"
export * from "./GsaApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports